var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "getStartedContainer", attrs: { "data-aos": "zoom-in" } },
    [
      _c(
        "div",
        { staticClass: "getStartedDiv has-text-white has-text-centered" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step == 1 || _vm.step == 11,
                  expression: "step == 1 || step == 11"
                }
              ],
              staticClass: "has-text-left"
            },
            [
              _c("div", [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "is-inline-block posRel" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.slink,
                        expression: "slink"
                      }
                    ],
                    staticClass: "niceInput larger is-inline-block",
                    attrs: {
                      id: "slinkField",
                      type: "text",
                      name: "slinkinput",
                      autocomplete: "slinkinput",
                      placeholder: _vm.placeholder
                    },
                    domProps: { value: _vm.slink },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.doSlink.apply(null, arguments)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.slink = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-turk has-text-black",
                      attrs: { id: "goSlinkButt" },
                      on: { click: _vm.doSlink }
                    },
                    [_vm._v("GO")]
                  )
                ]),
                _vm._v(" "),
                _vm.step == 11
                  ? _c("div", { staticClass: "is-size-4 top20" }, [
                      _vm._v("Sorry, this slink is already in use")
                    ])
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step == 2,
                  expression: "step == 2"
                }
              ]
            },
            [
              _c("div", { staticClass: "is-size-4 top10" }, [
                _c("span", { staticClass: "has-text-white" }, [
                  _vm._v("slink.com/"),
                  _c("span", { staticClass: "has-text-yell is-size-3" }, [
                    _c("b", [_vm._v(_vm._s(_vm.slink))])
                  ]),
                  _vm._v(" is available.")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "top10" }, [
                _c(
                  "button",
                  {
                    staticClass: "button  is-mag bottom5",
                    on: { click: _vm.tryIt }
                  },
                  [_c("b", [_vm._v("Try For Free")])]
                ),
                _vm._v(" \n                "),
                _c(
                  "button",
                  { staticClass: "button  is-mag", on: { click: _vm.addIt } },
                  [_c("b", [_vm._v("Add to Cart")])]
                ),
                _vm._v(" \n                "),
                _c(
                  "button",
                  { staticClass: "button ", on: { click: _vm.cancel } },
                  [_c("b", [_vm._v("Cancel")])]
                ),
                _vm._v(" \n            ")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step == 3,
                  expression: "step == 3"
                }
              ],
              staticClass: "top10"
            },
            [
              _c(
                "div",
                { staticClass: "is-size-4 lineHeight4b has-text-white" },
                [
                  _vm._v("Where would you like to point the slink, "),
                  _c("span", { staticClass: "has-text-yell" }, [
                    _c("b", [_vm._v(_vm._s(_vm.slink))]),
                    _vm._v("?")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "is-inline-block posRel" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.url,
                      expression: "url"
                    }
                  ],
                  staticClass: "niceInput larger top20",
                  attrs: {
                    type: "text",
                    placeholder: "enter or copy/paste URL"
                  },
                  domProps: { value: _vm.url },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.url = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "top15 has-text-white" }, [
                _vm._v(
                  "This can be a webpage, social media profile or post, etc..."
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "top20" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-mag",
                    on: {
                      click: function($event) {
                        return _vm.nextVal(4)
                      }
                    }
                  },
                  [_c("b", [_vm._v("Next")])]
                ),
                _vm._v(" \n                "),
                _c(
                  "button",
                  { staticClass: "button", on: { click: _vm.cancel } },
                  [_c("b", [_vm._v("Cancel")])]
                ),
                _vm._v(" \n            ")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step == 4,
                  expression: "step == 4"
                }
              ],
              staticClass: "top20"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.$root.isAuth,
                      expression: "!$root.isAuth"
                    }
                  ]
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.exists,
                          expression: "!exists"
                        }
                      ],
                      staticClass: "has-text-white"
                    },
                    [
                      _c("div", { staticClass: "is-size-4" }, [
                        _vm._v("If you have an account please "),
                        _c(
                          "button",
                          {
                            staticClass: "button is-small  is-mag",
                            on: { click: _vm.$root.showModalLogin }
                          },
                          [_vm._v("LOG IN")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "is-size-5 top20" }, [
                        _vm._v("if not, what is your email address?")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email,
                            expression: "email"
                          }
                        ],
                        staticClass: "niceInput larger top10",
                        attrs: {
                          type: "text",
                          placeholder: "enter your email address"
                        },
                        domProps: { value: _vm.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.email = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "top20" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-mag",
                            attrs: { id: "chkButt" },
                            on: { click: _vm.checkEmail }
                          },
                          [_c("b", [_vm._v("Next")])]
                        ),
                        _vm._v(" \n                        "),
                        _c(
                          "button",
                          { staticClass: "button", on: { click: _vm.cancel } },
                          [_c("b", [_vm._v("Cancel")])]
                        ),
                        _vm._v(" \n                    ")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.exists,
                          expression: "exists"
                        }
                      ],
                      staticClass: "has-text-white"
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.FCP,
                              expression: "!FCP"
                            }
                          ]
                        },
                        [
                          _c("div", { staticClass: "is-size-4" }, [
                            _vm._v(
                              "An account under this email already exists."
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "is-size-4 top10" }, [
                            _vm._v("Please "),
                            _c(
                              "button",
                              {
                                staticClass: "button is-mag top-5",
                                on: { click: _vm.$root.showModalLogin }
                              },
                              [_vm._v("LOG IN")]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.FCP,
                              expression: "FCP"
                            }
                          ]
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("div", { staticClass: "is-size-4" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button is-mag top10",
                                on: { click: _vm.resend }
                              },
                              [_vm._v("Resend")]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button  top20",
                          on: { click: _vm.cancel }
                        },
                        [_c("b", [_vm._v("Cancel")])]
                      ),
                      _vm._v(" \n                ")
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.$root.isAuth,
                      expression: "$root.isAuth"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "is-size-4" }, [
                    _c("span", { staticClass: "has-text-white" }, [
                      _vm._v("slink.com/")
                    ]),
                    _c("b", [
                      _c("span", { staticClass: "has-text-yell is-size-3" }, [
                        _vm._v(_vm._s(_vm.slink) + " ")
                      ]),
                      _c("span", { staticClass: "has-text-white" }, [
                        _vm._v("is ready!")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top20" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-mag ",
                        attrs: { id: "startTrialButt" },
                        on: { click: _vm.authTrial }
                      },
                      [_c("b", [_vm._v("Start Trial")])]
                    ),
                    _vm._v("  \n                    "),
                    _c(
                      "button",
                      { staticClass: "button ", on: { click: _vm.cancel } },
                      [_c("b", [_vm._v("Cancel")])]
                    ),
                    _vm._v(" \n                ")
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step == 6,
                  expression: "step == 6"
                }
              ],
              staticClass: "top20"
            },
            [
              !_vm.$root.isAuth
                ? _c("div", { staticClass: "has-text-white" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _vm._m(4),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button is-mag top15",
                        on: { click: _vm.cancel }
                      },
                      [_vm._v("OK")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$root.isAuth
                ? _c("div", { staticClass: "has-text-white" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _vm._m(6),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button is-mag top15",
                        on: { click: _vm.cancel }
                      },
                      [_vm._v("OK")]
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step == 8,
                  expression: "step == 8"
                }
              ],
              staticClass: "top20 has-text-white"
            },
            [
              _vm._m(7),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "button top15", on: { click: _vm.cancel } },
                [_c("b", [_vm._v("OK")])]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step == 9,
                  expression: "step == 9"
                }
              ],
              staticClass: "top20 has-text-white"
            },
            [_vm._m(8)]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mainTFLabel isPoppins" }, [
      _c("b", [_vm._v("slink.com/")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "is-size-4" }, [
      _vm._v(
        "You have already initiated another trial with this email address."
      ),
      _c("br"),
      _vm._v(
        " Please check your email for an activation link, or click the button below to have it resent."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "is-size-3" }, [
      _c("b", [_vm._v("Check your email!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("b", [_vm._v("Verify your email to activate your Slink trial.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top15 is-size-4 " }, [
      _vm._v(" Your slink will expire in "),
      _c("span", { staticClass: "has-text-yell" }, [
        _c("b", [_vm._v("30 days")])
      ]),
      _vm._v(" unless you purchase it before that.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "is-size-4" }, [
      _c("b", [_vm._v("Your Trial is set!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top20 is-size-5 " }, [
      _vm._v("You can change it's redirection URL and add subslinks from the "),
      _c("b", [_vm._v("Manage Services")]),
      _vm._v(" section of your account.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "is-size-4" }, [
      _c("b", [_vm._v("Sorry, but someone beat you to reserving this slink.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "is-size-4" }, [
      _c("b", [_vm._v("Cannot repeat trial of a slink")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d8e78fb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d8e78fb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GetStarted.vue
// module id = null
// module chunks = 